import React from 'react'

const AddCampaign = () => {
  return (
    <div>AddCampaign</div>
  )
}

export default AddCampaign